import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { FINANCING_KIND_LABELS, FINANCING_STATUS_LABELS, formatCents, type Financing, type Paginated } from '@kontor/shared';
import { api } from '../../api';
import { CollapsibleCard } from '../../components/CollapsibleCard';
import { useSession } from '../../session';
import { formatDay } from './shared';

/** Finanzierungen und Leasings eines Fahrzeugs (KON-253), als Bereich in der Fahrzeugmaske. Erscheint nur mit dem Modul und dem Recht zum Ansehen. */
export function VehicleFinancing({ vehicleId }: { vehicleId: string }) {
  const { hasModule, can } = useSession();
  const allowed = hasModule('financing') && can('financing.read');
  const list = useQuery({ queryKey: ['financing-list', { vehicleId }], queryFn: async () => (await api<Paginated<Financing>>('GET', `/financing?vehicleId=${vehicleId}&perPage=20`)).data, enabled: allowed });
  if (!allowed || !list.data || list.data.length === 0) return null;
  return (
    <CollapsibleCard title="Finanzierung und Leasing" storageKey="fleet-financing" defaultOpen>
      <ul className="inv-list">
        {list.data.map((f) => (
          <li key={f.id}>
            <Link to={`/finanzierungen/${f.id}`}>{f.number} · {f.title}</Link> · {FINANCING_KIND_LABELS[f.kind]} bei {f.lenderName} · Rate {formatCents(f.installmentCents)} · {f.status === 'active' ? `${f.kind === 'lease' ? 'Restverpflichtung' : 'Restschuld'} ${formatCents(f.summary.debtCents)}, Ende ${formatDay(f.summary.endDate)}` : FINANCING_STATUS_LABELS[f.status]}
          </li>
        ))}
      </ul>
    </CollapsibleCard>
  );
}
